import React, { useEffect, useState } from "react"
import { Alert, Button, Spinner } from "reactstrap"
import { obtenerEstado } from "api/migracionApi"
import { INTERVALO_LENTO_MS } from "hooks/useEstadoMigracion"
import { corridaVivaDe } from "./corridaVivaHelpers"

/**
 * Banner "Importación en curso — ver progreso" (re-enganche, ref. BDSJEA-364).
 *
 * - Con la prop `estado` (JSON crudo de /estado) es presentacional: se muestra
 *   si describe una corrida viva y no consulta nada (lo usa el IDLE del modal).
 * - Sin la prop consulta /estado por su cuenta al montar y cada 10 s mientras
 *   esté montado (lo usa la fase HISTORIAL); desaparece cuando la corrida
 *   termina. Un fallo de consulta conserva el último valor.
 *
 * @param {object}   [estado]       JSON crudo de GET /estado
 * @param {function} onVerProgreso  recibe el JSON crudo de la corrida viva
 */
const BannerImportacionEnCurso = ({ estado, onVerProgreso }) => {
  const consultaPropia = estado === undefined
  const [consultado, setConsultado] = useState(null)

  useEffect(() => {
    if (!consultaPropia) return undefined
    let vigente = true
    let timer = null
    const consultar = async () => {
      try {
        const data = await obtenerEstado()
        if (!vigente) return
        setConsultado(corridaVivaDe(data))
      } catch {
        // se conserva el último valor conocido
      }
      if (vigente) timer = setTimeout(consultar, INTERVALO_LENTO_MS)
    }
    consultar()
    return () => {
      vigente = false
      if (timer) clearTimeout(timer)
    }
  }, [consultaPropia])

  const viva = consultaPropia ? consultado : corridaVivaDe(estado)
  if (!viva) return null

  return (
    <Alert
      color="info"
      fade={false}
      className="d-flex align-items-center py-2"
      data-testid="banner-importacion-en-curso"
    >
      <Spinner size="sm" color="primary" className="me-2" />
      <span>Importación en curso</span> <span className="mx-1">—</span>{" "}
      <Button
        color="link"
        size="sm"
        className="p-0 align-baseline"
        onClick={() => onVerProgreso && onVerProgreso(viva)}
      >
        ver progreso
      </Button>
    </Alert>
  )
}

export default BannerImportacionEnCurso
